module.exports = __webpack_public_path__ + "img/layout-three-icon-17022022.fb7ee5a9.svg";